import { rem } from "polished";
import { ThemeKind } from "src/types";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

export const VideoGridContainer = withViewportStyle("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  ${(props) => props.$viewport.tablet`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(40)};

  .text-primitive {
    color: ${({ theme }) => {
      const colorKey =
        theme.themeKind === `${ThemeKind.NOLAN}`
          ? ColorLabels.PRIMARY_FONT
          : ColorLabels.SECONDARY_FONT;

      return theme.colors[colorKey];
    }};
  }
`;

export const BlockPadding = styled.div`
  padding: ${rem(24)};
`;

export const EmptyBlockMessage = styled.p`
  display: block;
  align-items: center;
  text-align: center;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  gap: ${rem(16)};
  padding: ${rem(16)} 0;
  color: ${({ theme }) => {
    const colorKey =
      theme.themeKind === `${ThemeKind.NOLAN}`
        ? ColorLabels.PRIMARY_FONT
        : ColorLabels.SECONDARY_FONT;

    return theme.colors[colorKey];
  }};
`;
